"use strict";

const EventEmitter = require("events");
const AdvancedFilter = require("./AdvancedFilterComponent");
const _ = require("lodash");
const PopUp = require("@gluenetworks/steve_ui_widgets").PopUp;

/**
 * as advanced filter is designed to be independent component
 * the Wrapper will connect it to the grid
 */

class AdvancedFilterWrapper extends EventEmitter {
    constructor(gridModel, options) {
        super();

        this._gridModel = gridModel;
        this._rootElem = document.createElement("entity-grid-gl-advanced-filter");
        this._advancedFilterIcon = this._createIcon();

        this._advancedFilterPopupContent = document.createElement("div");
        this._advancedFilterPopupContent.classList.add("advanced-filter-pop-up-content");

        this._arrowUp = document.createElement("div");
        this._arrowUp.classList.add("arrow");

        this._type = _.get(options, "type", false);

        this._filterQuery = _.get(options, "filterData", {});
        this._columnsConfig = this._getColumnsConfig(_.get(options, "columnsData", []));
        const additionalFilter = _.get(options, "additionalFilter", []);
        if (!_.isEmpty(additionalFilter)) {
            this._columnsConfig = _.concat(this._columnsConfig, additionalFilter);
        }

        this._advancedFilterPopup = new PopUp({
            hideDelayTime: 1000,
            anchor: this._advancedFilterIcon,
            anchorPoint: "bottomLeft",
            displayDirection: "bottomRight",
            content: this._advancedFilterPopupContent,
            parent: this._advancedFilterIcon,
            allowClickInside: true,
        });

        this._advancedFilter = new AdvancedFilter({
            filterData: this._filterQuery,
            columnsConfig: this._columnsConfig,
            type: this._type,
        });

        this._openAdvancedFilter = this._openAdvancedFilter.bind(this);
        this._onMongoQueryChanged = this._onMongoQueryChanged.bind(this);
        this._closeAdvancedFilter = this._closeAdvancedFilter.bind(this);
        this._onPopupVisible = this._onPopupVisible.bind(this);
        this._resetAdvancedFilter = this._resetAdvancedFilter.bind(this);

        this._registerListeners();
    }

    getRootElement() {
        return this._rootElem;
    }

    _registerListeners() {
        this._advancedFilterPopup.on("Visible", this._onPopupVisible);
        this._gridModel.on("BasicSearchFilterChangeData", this._resetAdvancedFilter);

        this._registerAdvancedFilterListeners();
    }

    _unRegisterListeners() {
        this._advancedFilterPopup.removeListener("Visible", this._onPopupVisible);
        this._gridModel.removeListener("BasicSearchFilterChangeData", this._resetAdvancedFilter);
        this._unRegisterAdvancedFilterListeners();
    }

    _registerAdvancedFilterListeners() {
        this._unRegisterAdvancedFilterListeners();
        this._advancedFilter.on("MongoQueryChanged", this._onMongoQueryChanged);
        this._advancedFilter.on("AdvancedFilterClose", this._closeAdvancedFilter);
    }

    _unRegisterAdvancedFilterListeners() {
        if (!this._advancedFilter) {
            return;
        }
        this._advancedFilter.removeListener("MongoQueryChanged", this._onMongoQueryChanged);
        this._advancedFilter.removeListener("AdvancedFilterClose", this._closeAdvancedFilter);
    }

    _getGridRootElement() {
        return this._gridModel.renderer.rootElement;
    }

    _resetAdvancedFilter() {
        if (!_.isEmpty(this._filterQuery)) {
            this._filterQuery = {};
            this.emit("AdvancedFilterChange", {}, {silent: true});
        }
    }

    _openAdvancedFilter() {
        this._advancedFilterPopup.setVisible(true);
    }
    _closeAdvancedFilter() {
        this._advancedFilterPopup.setVisible(false);
    }

    _onPopupVisible(isVisibble) {
        if (isVisibble) {
            const gridRoot = this._getGridRootElement(),
                treeContainer = document.getElementsByTagName("tree-container"),
                treeContainerWidth = _.get(treeContainer, "0.offsetWidth", 0);

            const maxWidth =
                gridRoot.offsetWidth +
                treeContainerWidth -
                this._advancedFilterPopupContent.getBoundingClientRect().left;
            const maxHeight = gridRoot.offsetHeight - this._advancedFilterPopupContent.offsetTop;

            this._advancedFilterPopupContent.style.maxWidth = `${maxWidth}px`;

            if (this._type.name === "special") {
                this._advancedFilter.setQuery(this._type.filterQuery);
            } else {
                this._advancedFilter.setQuery(this._filterQuery);
            }
            this._advancedFilter.updateHeight(maxHeight);
        }
    }

    _onMongoQueryChanged(mongoQuery) {
        this._filterQuery = mongoQuery;
        this.emit("AdvancedFilterChange", mongoQuery);
        // this._closeAdvancedFilter();
    }

    render() {
        if (!this._advancedFilterPopupContent.hasChildNodes()) {
            this._advancedFilterPopupContent.innerHTML = "";
            this._advancedFilterPopupContent.appendChild(this._arrowUp);
            let advancedFilterRootElement = this._advancedFilter.renderer.rootElement;
            advancedFilterRootElement.setAttribute("title", "");
            this._advancedFilterPopupContent.appendChild(advancedFilterRootElement);
        }

        return new Promise((resolve) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._advancedFilterIcon);
            }
            resolve();
        });
    }

    shutdown() {
        this._unRegisterListeners();
        this._rootElem.remove();
        this._rootElem = null;
        this._advancedFilterIcon = null;
        this._advancedFilter = null;

        // TODO New attributes to be added

        return Promise.resolve();
    }

    _createIcon() {
        const filterIcon = document.createElement("actionable-icon-gl");
        filterIcon.dataset.icon = "toggle.sort";
        filterIcon.setAttribute("title", "Advanced Filter");
        filterIcon.setAttribute("data-dark-theme", "true");
        return filterIcon;
    }

    _getColumnsConfig(columnsData) {
        return columnsData.map((colData) => {
            //handles both {name, title} and {value, title} option formats
            const options = _.values(colData.options).map((opt) => ({
                value: opt.name !== undefined ? opt.name : opt.value,
                label: opt.title !== undefined ? opt.title : opt.label,
            }));

            if (colData.filterLabel) {
                colData.label = colData.filterLabel;
            }

            //pass in type info
            return Object.assign({}, colData, {options, typeInfo: colData.typeInfo});
        });
    }
}

module.exports = AdvancedFilterWrapper;
